const state = {
  masterProviders: [],
  masterProvider: {},
};

export default state;
